import {useDispatch, useSelector} from "react-redux";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {FIELD_LIST_INPUT_JOIN_MEMBER_LOYALTY_PROGRAM} from "../../utils/input-field-list-static-page";
import {setLoyaltyProgramErrorMessage, setLoyaltyProgramJoinMemberDetail} from "../../reducers/loyalty-program.reducer";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../reducers/tools.reducer";
import {convertErrorMessage} from "../../utils/general-variable";
import React, {useEffect} from "react";
import FormGeneralComponent from "../../components/static-page/form-general.component";

const JoinMember = () => {
    const dispatch = useDispatch()
    const {joinMemberDetail, loyaltyProgramErrorMessage} = useSelector(state => state.loyaltyProgramReducer)
    const {fetching: getJoinMember} = useFetch(API.LOYALTY_PROGRAM_GET_JOIN_MEMBER)
    const {fetching: updateJoinMember, isLoading} = useFetch(API.LOYALTY_PROGRAM_UPDATE_JOIN_MEMBER)
    let fieldListInput = FIELD_LIST_INPUT_JOIN_MEMBER_LOYALTY_PROGRAM
    let showJoinMember = {
        label: 'Join Member',
        key: 'show_join_member',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setLoyaltyProgramJoinMemberDetail({[key]: value}))
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        updateJoinMember(joinMemberDetail).then(response => {
            dispatch(setLoyaltyProgramErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('Join Member Updated'))
            dispatch(setLoyaltyProgramJoinMemberDetail(response?.data))
        }).catch(err => {
            dispatch(setLoyaltyProgramErrorMessage(convertErrorMessage(err)))
        })
    }

    useEffect(() => {
        getJoinMember().then(response => {
            dispatch(setLoyaltyProgramJoinMemberDetail(response?.data))
        })

        return () => {
            dispatch(setLoyaltyProgramErrorMessage({}))
        }
    }, [])

    return (
        <FormGeneralComponent
            data={joinMemberDetail}
            switchToggleField={showJoinMember}
            fieldList={fieldListInput}
            onChange={onChange}
            onSubmitHandler={onSubmitHandler}
            inputClassName={'grid grid-cols-2 gap-x-16 gap-y-4'}
            errorMessage={loyaltyProgramErrorMessage}
            isLoading={isLoading}
        />
    )
}

export default JoinMember
